module.exports = __webpack_public_path__ + "img/stat_basic_en_mobile.7b39bfb9.png";